import {
  USER_LOGOUT,
  VERIFY_TOKEN_END,
  VERIFY_TOKEN_STARTED,
  USER_LOGIN_FAILURE,
  VERIFY_USER_PHONE,
  VERIFY_USER_CODE,
  REGISTERD,
  VERIFY_USER_REGISTERED,
  USER_LOGIN_STARTED,
  CALC_PRICE,
  CLEAR_INITIAL,
} from "../../utils/stringConsts";

export const verifyTokenStarted = (silentAuth = false) => {
  return {
    type: VERIFY_TOKEN_STARTED,
    payload: {
      silentAuth,
    },
  };
};

export const verifyTokenEnd = () => {
  return {
    type: VERIFY_TOKEN_END,
  };
};

export const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};

export const verifyUserPhone = ({ accessToken, expiredAt, fullName }) => {
  return {
    type: VERIFY_USER_PHONE,
    payload: {
      accessToken,
      fullName,
      expiredAt,
    },
  };
};

export const verifyUserRegistered = () => {
  return {
    type: VERIFY_USER_REGISTERED,
  };
};

export const verifyUserLogin = ({ accessToken, expiredAt, fullName }) => {
  return {
    type: USER_LOGIN_STARTED,
    payload: {
      accessToken,
      expiredAt,
      fullName,
    },
  };
};

export const verifyUserCode = (result) => {
  let codeValidMessage;
  if (result.data) {
    codeValidMessage = "کد تایید شد";
  }
  return {
    type: VERIFY_USER_CODE,
    payload: {
      codeValidMessage,
    },
  };
};

export const registered = ({ success, data }) => {
  const { accessToken, expiredAt, fullName } = data;

  return {
    type: REGISTERD,
    payload: {
      accessToken,
      expiredAt,
      fullName,
      success,
    },
  };
};

export const userLoginFailure = (error = "", message) => {
  return {
    type: USER_LOGIN_FAILURE,
    payload: {
      error,
      message,
    },
  };
};

export const calcPrice = ({ success, price }, packing, assurance, pickup) => {
  return {
    type: CALC_PRICE,
    payload: {
      success,
      price,
      packing,
      assurance,
      pickup,
    },
  };
};

export const clearInitial = () => {
  return {
    type: CLEAR_INITIAL,
    payload: {
      section: 1,
      originLat: " 51.40143",
      originLng: "32.4201",
      serviceType: "",
      deliveryType: "",
      fullName: null,
      phoneNumber: null,
      destination: 28,
      address: null,
      addressSender: null,
      postalCode: null,
      packages: [],
      packing: [],
      paymentTime: "پیشکرایه",
      assurance: {
        stat: false,
        value: null,
      },
      serviceFee: {
        stat: false,
        value: null,
        desc: "",
      },
      price: null,
      paymentType: "",
      packSize: [],
      cityName: "",
      origin: null,
      cities: [],
      states: [],
    },
  };
};
